import cx from 'clsx';

import styles from './content.module.css';

export interface DocumentBodyProps {
  className?: string;
  html: string;
}

export function DocumentBody({ className, html }: DocumentBodyProps) {
  return (
    <div
      className={cx(styles.markdown, className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
